import React, { useCallback, useState } from "react";
import { useHistory } from "react-router";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import DateRangeIcon from "@material-ui/icons/DateRange";
import PersonIcon from "@material-ui/icons/Person";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { useSelector, useDispatch } from "react-redux";
import useMedia from "use-media";

import {
  selectTargetUser,
  initialState,
  setSearchCategory,
  fetchAsyncGetRecords,
  fetchAsyncGetOriginalRecords,
} from "../../features/home/homeSlice";

import {
  selectLoginUser,
  fetchAsyncGetLoginProfile,
  selectLoginUserProfile,
} from "../../features/auth/authSlice";

import { setProfiles } from "../../features/auth/authSlice";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#2699FB",
    zIndex: 999,
    maxWidth: "66.667%",
    margin: "0 auto",
  },
  rootRes: {
    width: "100%",
    backgroundColor: "#2699FB",
    zIndex: 999,
  },
  item: {
    color: "#fff",
  },
  zIndex: {
    zIndex: 999,
  },
}));

const Footer: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const loginUser = useSelector(selectLoginUser);
  const loginUserProfile = useSelector(selectLoginUserProfile);
  const isWide = useMedia({ minWidth: "600px" });

  //月初取得関数
  const getFirstDate = (date: any) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };
  //月末取得関数
  const getLastDate = (date: any) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  const onClickHome = useCallback(async () => {
    const fetchBootLoader = async () => {
      let first_date = getFirstDate(new Date());
      let last_date = getLastDate(new Date());
      //カレンダーの表示対象を判別 selectedUserにidが存在する場合、他ユーザのレコードを取得
      let target_user_id = loginUser.id;

      const para = {
        user_id: target_user_id,
        date_after: `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`,
        date_before: `${last_date.getFullYear()}-${
          last_date.getMonth() + 1
        }-${last_date.getDate()}`,
      };

      await dispatch(fetchAsyncGetRecords(para));
      await dispatch(fetchAsyncGetOriginalRecords(para));
      await dispatch(selectTargetUser(initialState.selectedUser));
    };
    await fetchBootLoader();
    await history.push("/home");
  }, [history]);

  //プロフィールボタン押下時
  const onClickProfile = async () => {
    await dispatch(selectTargetUser(initialState.selectedUser));
    //ログインユーザのプロフィールデータがなかったら取得
    loginUserProfile.user_profile === 0 &&
      (await dispatch(fetchAsyncGetLoginProfile()));
    await history.push("/home/profile");
  };
  //メニューバーのsearchを押下時、検索結果をリセットする
  const onClickSearch = useCallback(async () => {
    await dispatch(
      setProfiles([
        {
          id: 0,
          username: "",
          user_profile: 0,
          img: null,
          gender_flg: "",
          height: null,
          height_hide_flg: "",
          weight: null,
          weight_hide_flg: "",
          text: null,
          calendar_hide_flg: "",
        },
      ])
    );
    await dispatch(
      setSearchCategory({
        height: 0,
        weight: 0,
        gender: "",
        searchWord: "",
      })
    );
    await history.push("/home/search");
  }, [history]);

  const [value, setValue] = useState("");

  return (
    <Grid container component="footer" className={classes.zIndex}>
      <Grid item xs={12}>
        <BottomNavigation
          value={value}
          className={isWide ? classes.root : classes.rootRes}
        >
          <BottomNavigationAction
            label="Search"
            icon={<SearchIcon />}
            onClick={onClickSearch}
            className={classes.item}
            value="/home/search"
          />
          <BottomNavigationAction
            label="Calendar"
            icon={<DateRangeIcon />}
            onClick={onClickHome}
            className={classes.item}
            value="/home"
          />
          <BottomNavigationAction
            label="Profile"
            icon={<PersonIcon />}
            onClick={onClickProfile}
            className={classes.item}
            value="/home/profile"
          />
        </BottomNavigation>
      </Grid>
    </Grid>
  );
};

export default Footer;
